/* Shipping and totals are rendered from current cart state by Liquid. */
(() => {
  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || !event.target.matches('#cart-drawer [data-discount-input]')) return;
    event.preventDefault();
    event.target.closest('cart-drawer').querySelector('[data-apply-discount]')?.click();
  });
})();
